import React from "react";
import FAQ from "./FAQ.jsx";
import idustrialaluminium from "../Images/idustrialscrap.png";
import Wheelscrap from "../Images/Wheelscrap.png";
import wirescrap from "../Images/wirescrap.png";
import AIgnotscrap from "../Images/AIgnotscrap.png";
import almuniumscrap from "../Images/almuniumscrap.png";
import profilescrap from "../Images/profilescrap.png";
import alsheetscrap from "../Images/alsheetscrap.png";
import SEO from "../Components/SEO";

const aluminumScrap = [
  {
    id: 1,
    title: "Aluminum Ingot Scrap",
    image: AIgnotscrap,
  },
  {
    id: 2,
    title: "Aluminum Sheet Scrap",
    image: alsheetscrap,
  },
  {
    id: 3,
    title: "Aluminum Wire Scrap",
    image: wirescrap,
  },
  {
    id: 4,
    title: "Aluminum Profile Scrap",
    image: profilescrap,
  },
  {
    id: 5,
    title: "Aluminum Wheel Scrap",
    image: Wheelscrap,
  },
  {
    id: 6,
    title: "Industrial Aluminum Scrap",
    image: idustrialaluminium,
  },
];

const AluminumScrap = () => {
  return (
    <>
      <SEO 
        title="Aluminium Scrap Recycling & Supply" 
        description="High-grade aluminium scrap recycling, including aluminium sheets, profiles, wires, and ingots. Best prices in Delhi NCR."
        keywords="aluminium scrap, aluminium wire scrap, aluminium sheet scrap, aluminium profiles, recycle aluminium"
      />
      <style>{`
      *{
        margin:0;
        padding:0;
        box-sizing:border-box;
        font-family:Arial,Helvetica,sans-serif;
      }

      .hero{
    background:#ffffff;
    padding:90px 8%;
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:60px;
    flex-wrap:wrap;
}
      .hero-content{
    flex:1;
    min-width:320px;
}

      .hero-content h1{
    color:#0A2E73;
    font-size:55px;
    font-weight:700;
    margin-bottom:20px;
    line-height:1.2;
}

.hero-content p{
    color:#555;
    font-size:18px;
    line-height:1.9;
    margin-bottom:30px;
}

.hero-image{
    flex:1;
    min-width:320px;
}

.hero-image img{
    width:100%;
    border-radius:20px;
    box-shadow:0 20px 40px rgba(0,0,0,.15);
}

.hero-btn{
    display:inline-block;
    padding:15px 35px;
    background:#0A2E73;
    color:#FFD700;
    text-decoration:none;
    border-radius:40px;
    font-weight:bold;
    transition:.3s;
}

.hero-btn:hover{
    background:#FFD700;
    color:#0A2E73;
}

      .content{
        padding:80px 8%;
        background:#fff;
      }

      .content h2{
        color:#0A2E73;
        text-align:center;
        font-size:40px;
        margin-bottom:25px;
      }

      .content p{
        color:#555;
        line-height:1.9;
        font-size:17px;
        text-align:center;
        max-width:1000px;
        margin:auto;
      }

      .gallery-section{
        background:#f7f8fc;
        padding:80px 8%;
      }

      .gallery-title{
        text-align:center;
        margin-bottom:50px;
      }

      .gallery-title h2{
        color:#0A2E73;
        font-size:40px;
      }

      .gallery{
        display:grid;
        grid-template-columns:repeat(auto-fit,minmax(320px,1fr));
        gap:30px;
      }

      .card{
        background:#fff;
        border-radius:15px;
        overflow:hidden;
        box-shadow:0 10px 30px rgba(0,0,0,.12);
        transition:.4s;
      }

      .card:hover{
        transform:translateY(-10px);
      }

      .card img{
        width:100%;
        height:250px;
        object-fit:cover;
      }

      .card-body{
        padding:22px;
      }

      .card-body h3{
        color:#0A2E73;
        margin-bottom:12px;
      }

      .card-body p{
        color:#666;
        line-height:1.7;
      }

      .features{
        padding:80px 8%;
        background:#fff;
      }

      .features h2{
        text-align:center;
        color:#0A2E73;
        margin-bottom:50px;
        font-size:40px;
      }

      .feature-grid{
        display:grid;
        grid-template-columns:repeat(auto-fit,minmax(250px,1fr));
        gap:25px;
      }

      .feature{
        background:#f8f8f8;
        padding:30px;
        border-radius:12px;
        text-align:center;
        transition:.3s;
      }

      .feature:hover{
        background:#0A2E73;
        color:white;
      }

      .feature h3{
        margin-bottom:15px;
      }

      .cta{
        background:#0A2E73;
        color:white;
        padding:80px 8%;
        text-align:center;
      }

      .cta h2{
        font-size:40px;
        margin-bottom:20px;
      }

      .cta p{
        max-width:850px;
        margin:auto;
        line-height:1.8;
      }

      .btn{
        display:inline-block;
        margin-top:30px;
        padding:15px 35px;
        background:#FFD700;
        color:#0A2E73;
        text-decoration:none;
        border-radius:40px;
        font-weight:bold;
        transition:.3s;
      }

      .btn:hover{
        background:white;
      }

      @media(max-width:768px){

      .hero h1{
      font-size:38px;
      }

      .content h2,
      .gallery-title h2,
      .features h2,
      .cta h2{
      font-size:30px;
      }

      }
      `}</style>

      <section className="hero">

    <div className="hero-content">

        <h1>Premium Aluminum Scrap Dealer in Delhi(NCR)</h1>

        <p>
            We buy and sell all kinds of aluminum scrap including sheets,
            profiles, wires, wheels, machine parts and industrial aluminum
            waste. We provide premium quality recyclable aluminum scrap at
            competitive prices with fast pickup and instant payment.
        </p>

        <a href="/contact" className="hero-btn">
            Get Best Price
        </a>

    </div>

    <div className="hero-image">

        <img
            src={almuniumscrap}
            alt="Aluminum Scrap"
            loading="lazy"
        />

    </div>

</section>

      <section className="content">
        <h2>About Aluminum Scrap</h2>

        <p>
          Aluminum is one of the most valuable recyclable metals because it can
          be recycled repeatedly without losing its quality. We purchase and
          supply all kinds of aluminum scrap including sheets, ingots, wires,
          profiles, wheels, machine parts, and industrial aluminum waste. Our
          commitment is to provide premium-quality recyclable materials at
          competitive prices while supporting sustainable environmental
          practices.
        </p>
      </section>

      <section className="gallery-section">

        <div className="gallery-title">
          <h2>Our Aluminum Scrap Gallery</h2>
        </div>

        <div className="gallery">

          {aluminumScrap.map((item) => (
            <div className="card" key={item.id}>

              <img src={item.image} alt={item.title} />

              <div className="card-body">

                <h3>{item.title}</h3>

                <p>
                  Premium quality recyclable aluminum scrap suitable for
                  industrial recycling and manufacturing purposes.
                </p>

              </div>

            </div>
          ))}

        </div>

      </section>

      <section className="features">

        <h2>Why Choose Us?</h2>

        <div className="feature-grid">

          <div className="feature">
            <h3>Premium Quality</h3>
            <p>High-grade aluminum scrap carefully sorted for recycling.</p>
          </div>

          <div className="feature">
            <h3>Best Market Price</h3>
            <p>Competitive pricing with complete transparency.</p>
          </div>

          <div className="feature">
            <h3>Fast Pickup</h3>
            <p>Quick collection service from industries and factories.</p>
          </div>

          <div className="feature">
            <h3>Trusted Partner</h3>
            <p>Reliable aluminum scrap supplier with years of experience.</p>
          </div>

        </div>

      </section>

      <section className="cta">

        <h2>Looking to Sell Aluminum Scrap?</h2>

        <p>
          Contact us today for the best aluminum scrap prices. We ensure fast
          pickup, accurate weight measurement, and instant payment.
        </p>

        <a href="/contact" className="btn">
          Contact Us
        </a>

      </section>
        <section><FAQ/></section>
    </>
  );
};

export default AluminumScrap;